const RevenueLineChart = ({ data }) => {
  if (!data || data.length === 0) return null;

  const chartData = [...data].sort((a, b) => new Date(a.date) - new Date(b.date));
  const width = 800;
  const height = 240;
  const paddingX = 65; // Tăng khoảng cách để chứa nhãn trục tung
  const paddingY = 40;

  const maxRevenue = Math.max(...chartData.map(d => d.revenue)) * 1.15;
  const minRevenue = 0;

  const getX = (index) => paddingX + (index * (width - 2 * paddingX) / (chartData.length - 1));
  const getY = (value) => (height - paddingY) - ((value - minRevenue) / (maxRevenue - minRevenue) * (height - 2 * paddingY));

  const points = chartData.map((d, i) => `${getX(i)},${getY(d.revenue)}`).join(' ');
  const areaPoints = `${getX(0)},${height - paddingY} ${points} ${getX(chartData.length - 1)},${height - paddingY}`;

  // Tạo các mốc cho trục tung (0, 25%, 50%, 75%, 100%)
  const yAxisTicks = [0, 0.25, 0.5, 0.75, 1];

  return (
    <div className="w-full h-72 mt-6 relative">
      <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-full overflow-visible">
        {/* Trục Tung & Lưới ngang */}
        {yAxisTicks.map((p, i) => {
          const val = maxRevenue * p;
          const yPos = getY(val);
          return (
            <g key={i}>
              {/* Lưới ngang */}
              <line 
                x1={paddingX} 
                y1={yPos} 
                x2={width - paddingX/2} 
                y2={yPos} 
                stroke="#f1f5f9" 
                strokeWidth="1" 
              />
              {/* Nhãn trục tung */}
              <text
                x={paddingX - 12}
                y={yPos + 4}
                textAnchor="end"
                className="text-[10px] font-bold fill-slate-400 font-mono"
              >
                {val >= 1000000 
                  ? `${(val / 1000000).toFixed(1)}M` 
                  : `${Math.round(val / 1000)}k`}
              </text>
            </g>
          );
        })}

        {/* Trục Tung (Đường dọc) */}
        <line 
          x1={paddingX} 
          y1={paddingY} 
          x2={paddingX} 
          y2={height - paddingY} 
          stroke="#f1f5f9" 
          strokeWidth="1.5" 
        />

        {/* Vùng đổ bóng */}
        <polyline
          points={areaPoints}
          fill="url(#chartGradient)"
          className="transition-all duration-1000 ease-in-out"
        />

        {/* Đường biểu đồ */}
        <polyline
          points={points}
          fill="none"
          stroke="#6366f1" 
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="transition-all duration-1000 ease-in-out"
        />

        {/* Các điểm nút */}
        {chartData.map((d, i) => (
          <g key={i} className="cursor-pointer group/node">
            <circle
              cx={getX(i)}
              cy={getY(d.revenue)}
              r="5"
              fill="#fff"
              stroke="#6366f1"
              strokeWidth="2.5"
              className="transition-all group-hover/node:r-7"
            />
            {/* Tooltip text */}
            <text
              x={getX(i)}
              y={getY(d.revenue) - 18}
              textAnchor="middle"
              className="text-[10px] font-black fill-indigo-600 opacity-0 group-hover/node:opacity-100 transition-opacity"
            >
              {new Intl.NumberFormat('vi-VN').format(Math.round(d.revenue / 1000))}k
            </text>
            {/* Nhãn trục hoành */}
            <text
              x={getX(i)}
              y={height - paddingY + 22}
              textAnchor="middle"
              className="text-[10px] font-bold fill-slate-400"
            >
              {d.date.split('-')[2]}/{d.date.split('-')[1]}
            </text>
          </g>
        ))}

        <defs>
          <linearGradient id="chartGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#6366f1" stopOpacity="0.12" />
            <stop offset="100%" stopColor="#6366f1" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default RevenueLineChart;
